import { Link, useParams } from "react-router-dom";
import { ArrowLeft, ArrowUpRight, Clock } from "@phosphor-icons/react";
import { BLOG_POSTS, CLINIC } from "../data/site";
import { Reveal } from "../components/Reveal";
import { CTABand } from "../components/CTABand";
import { EnquiryDialog } from "../components/EnquiryDialog";

export default function BlogPost() {
  const { id } = useParams();
  const post = BLOG_POSTS.find((p) => p.id === id) || BLOG_POSTS[0];

  return (
    <main data-testid="blog-post-page">
      <section className="border-b border-border bg-secondary/40 pb-14 pt-40">
        <div className="mx-auto max-w-3xl px-5 sm:px-8">
          <Reveal y={20}>
            <Link to="/blog" data-testid="blog-back-link" className="group inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.25em] text-muted-foreground transition-colors duration-300 hover:text-primary">
              <ArrowLeft size={14} className="transition-transform duration-300 group-hover:-translate-x-1" />
              Back to the Blog
            </Link>
            <div className="mt-8 flex items-center gap-4 text-[11px] uppercase tracking-[0.25em] text-muted-foreground">
              <span className="text-primary">{post.date}</span>
              <span>·</span>
              <span>By {post.author}</span>
              <span className="flex items-center gap-1.5"><Clock size={13} /> {post.readTime}</span>
            </div>
            <h1 className="mt-5 font-display text-4xl font-light leading-[1.05] tracking-tight sm:text-6xl" data-testid="blog-post-title">
              {post.title}
            </h1>
          </Reveal>
        </div>
      </section>

      <div className="mx-auto max-w-3xl px-5 py-14 sm:px-8">
        <Reveal>
          <img src={post.image} alt={post.title} className="aspect-[16/9] w-full object-cover" data-testid="blog-post-image" />
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-12 space-y-6" data-testid="blog-post-content">
            {post.content.map((p, i) => (
              <p key={i} className={`font-light leading-[1.85] text-foreground/90 ${i === 0 ? "font-display text-2xl italic leading-[1.5]" : "text-base"}`}>
                {p}
              </p>
            ))}
          </div>
          <div className="mt-12 border border-primary/25 bg-accent/50 p-8">
            <p className="text-sm font-light leading-relaxed">{post.cta}</p>
            <div className="mt-6 flex flex-col gap-3 sm:flex-row">
              <EnquiryDialog
                defaultType="consultation"
                defaultTreatment="Chemical Peels"
                trigger={
                  <button data-testid="blog-post-consultation-button" className="bg-primary px-6 py-3.5 text-xs font-medium uppercase tracking-[0.25em] text-primary-foreground transition-colors duration-300 hover:bg-primary/90">
                    Book a consultation
                  </button>
                }
              />
            </div>
          </div>
        </Reveal>
      </div>

      <CTABand />
    </main>
  );
}
